/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ips-expand-icon[_ngcontent-%COMP%]{position:absolute;top:-1px;right:-1px;background-color:#f0f0f0;border-bottom-left-radius:.25em;border-top-right-radius:.25em;width:20px;padding:4px}.ips-btn-image[_ngcontent-%COMP%]{max-width:100%}"];
export { styles as styles };
